module.exports = "ul {\r\n    padding: 0;\r\n    list-style-type: none;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/publishers/missing-report/missing-report.component.css
// module id = ./src/app/publishers/missing-report/missing-report.component.css
// module chunks = main